import { IFormulaDataReferenceElement } from '@shared/interfaces';

export const dataReferences: IFormulaDataReferenceElement[] = [];
